import { render, staticRenderFns } from "./ContainerEditor.vue?vue&type=template&id=c0b38d96&scoped=true"
import script from "./ContainerEditor.vue?vue&type=script&lang=js"
export * from "./ContainerEditor.vue?vue&type=script&lang=js"
import style0 from "./ContainerEditor.vue?vue&type=style&index=0&id=c0b38d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b38d96",
  null
  
)

export default component.exports